import { Dispatch, SetStateAction, useEffect, useState } from 'react';

export const LocalStorageKeys = {
  InviteTeamMemberBanner: 'invite-team-member-banner',
};

export const useLocalStorage = <T>(
  key: string,
  initialValue: T,
): [T, Dispatch<SetStateAction<T>>, () => void] => {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : initialValue;
    } catch (error) {
      console.warn(`useLocalStorage: Unable to parse localStorage key “${key}”.`, error);
      return initialValue;
    }
  });

  useEffect(() => {
    try {
      window.localStorage.setItem(key, JSON.stringify(storedValue));
    } catch (error) {
      console.warn(`useLocalStorage: Unable to set localStorage key “${key}”.`, error);
    }
  }, [key, storedValue]);

  const resetValue = () => {
    try {
      window.localStorage.removeItem(key);
    } catch (error) {
      console.warn(`useLocalStorage: Unable to remove localStorage key “${key}”.`, error);
    }
    setStoredValue(initialValue);
  };

  return [storedValue, setStoredValue, resetValue];
};
